import { PrimariaApi } from "@uxland/primary-shell";
import { ICiPdSDiagnosticFilter } from "../model";
import { SetDiagnosticFiltersValuesCommand } from "./set/request";

export const subscribeDiagnosticFilters = (api: PrimariaApi) => {
  api.broker.subscribe("cipds_diagnostic_filter_historic_requested", (payload: ICiPdSDiagnosticFilter) => {
    api.broker.send(new SetDiagnosticFiltersValuesCommand(payload));
  });
};
